import React from 'react';
import { TextField } from '@mui/material';

const CpdTextField = (props) => {
  return (
    <TextField fullWidth size='small' sx={{ mb: 2, ...props.sx }} {...props} />
  );
};

export default CpdTextField;
